import { SetStateAction, useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import TotvsBlackImg from "../../assets/images/logo-totvs-black.png";
import TotvsWhiteImg from "../../assets/images/logo-totvs-white.png";
import NinegridBlackImg from "../../assets/images/logo-ninegrid-black.png";
import NinegridWhiteImg from "../../assets/images/logo-ninegrid-white.png";
// import NinegridImg from '../../assets/images/ninegrid-logo.png';
// import TotvsImg from '../../assets/images/totvs-logo.png';
import { MainButton } from "../../components/MainButton";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import "./index.css";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useFoodConfig } from "../../hooks/useFood";
import { ModalComandaFood } from "../../components/ModalComandaFood/ModalComandaFood";
import { QrReader } from "../../components/QrCodeReader/QrCodeReader";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";

export function Home() {
  const navigate = useNavigate();
  const params = useParams();
  const { getAppConfig } = useAppConfig();
  const useFood = useFoodConfig();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [categoryId, setCategoryId] = useState("");
  const [pluginSpace, setPluginspace] = useState<any>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isOpenModalFood, setIsOpenModalFood] = useState<boolean>(false);

  const [openCamera, setOpenCamera] = useState<boolean>(false);
  const { trackPageView } = useFaceBookPixel();

  useEffect(() => {
    registerAccess("home");
    getConfig();
  }, [params]);
  async function getConfig() {
    try {
      setLoading(true);
      const _config = await getAppConfig();
      setConfig(_config);
      
      // Aguardar um pouco antes de processar table/card para evitar conflitos
      await new Promise(resolve => setTimeout(resolve, 100));
      
      loadTableCard(_config);
    } catch (error) {
      console.error("Erro ao carregar configuração:", error);
      // Continuar com configuração vazia em caso de erro
      setConfig(undefined);
      loadTableCard(undefined);
    } finally {
      setLoading(false);
    }
  }

  // Helper function to safely decode base64
  const safeAtob = (str: string): number | null => {
    try {
      if (!str) return null;
      const decoded = window.atob(str);
      const parsed = parseInt(decoded);
      return isNaN(parsed) ? null : parsed;
    } catch (error) {
      console.warn("Erro ao decodificar base64:", error);
      return null;
    }
  };

  // Helper function to safely navigate
  const safeNavigate = (path: string, options?: any) => {
    try {
      navigate(path, options);
    } catch (error) {
      console.error("Erro ao navegar:", error);
      // Fallback: tentar navegação simples
      try {
        window.location.href = path;
      } catch (fallbackError) {
        console.error("Erro no fallback de navegação:", fallbackError);
      }
    }
  };

  function loadTableCard(_config: ConfigType | void) {
    try {
      // Clear storage items safely
      const itemsToRemove = [
        "table_number", "table_name", "internal_number", "internal_name",
        "landmark_synkar", "counter_number"
      ];
      
      itemsToRemove.forEach(item => {
        try {
          localStorage.removeItem(item);
        } catch (error) {
          console.warn(`Erro ao remover ${item} do localStorage:`, error);
        }
      });

      try {
        localStorage.removeItem("card_number");
        localStorage.removeItem("card_name");
      } catch (error) {
        console.warn("Erro ao limpar localStorage:", error);
      }

      trackPageView();

      const isKicked = searchParams.get("kicked");
      const reload_app_food = localStorage.getItem("reload_app_food");
      const first_access = localStorage.getItem("first_access");

      if (!reload_app_food || !first_access) {
        const foodItems = ["food_customer_phone", "food_customer_name", "food_customer_call_waiter"];
        foodItems.forEach(item => {
          try {
            localStorage.removeItem(item);
          } catch (error) {
            console.warn(`Erro ao remover ${item}:`, error);
          }
        });
      }

      // Handle kicked status
      try {
        if (isKicked) {
          localStorage.setItem("was_kicked", "true");
        } else {
          localStorage.removeItem("was_kicked");
        }
      } catch (error) {
        console.warn("Erro ao gerenciar status kicked:", error);
      }

      // Process URL parameters safely
      if (params.landmark_synkar) {
        try {
          useFood.setIsLandmark(true);
          const landmarkNumber = safeAtob(params.landmark_synkar);
          if (landmarkNumber !== null) {
            useFood.setLandMarkNumber(landmarkNumber);
            localStorage.setItem("landmark_synkar", params.landmark_synkar);
          }
        } catch (error) {
          console.warn("Erro ao processar landmark:", error);
        }
      }

      if (params.table_number) {
        try {
          useFood.setIsTable(true);
          const tableNumber = safeAtob(params.table_number);
          if (tableNumber !== null) {
            useFood.setTableNumber(tableNumber);
            localStorage.setItem("table_number", params.table_number);
            localStorage.setItem("should_show_ler_qrcodeButton", "true");
          }
        } catch (error) {
          console.warn("Erro ao processar table_number:", error);
        }
      }

      if (params.table_name) {
        try {
          useFood.setTableName(params.table_name);
          localStorage.setItem("table_name", params.table_name);
        } catch (error) {
          console.warn("Erro ao processar table_name:", error);
        }
      }

      if (params.card_number) {
        try {
          useFood.setIsCard(true);
          const cardNumber = safeAtob(params.card_number);
          if (cardNumber !== null) {
            useFood.setCardNumber(cardNumber);
            localStorage.setItem("card_number", params.card_number);
            localStorage.setItem("should_show_ler_qrcodeButton", "true");
          }
        } catch (error) {
          console.warn("Erro ao processar card_number:", error);
        }
      }

      if (params.card_name) {
        try {
          useFood.setCardName(params.card_name);
          localStorage.setItem("card_name", params.card_name);
        } catch (error) {
          console.warn("Erro ao processar card_name:", error);
        }
      }

      if (params.counter_number) {
        try {
          useFood.setIsCounter(true);
          const counterNumber = params.counter_number;
          if (counterNumber !== null) {
            // useFood.setCounterNumber(counterNumber);
            localStorage.setItem("counter_number", params.counter_number);
          }
        } catch (error) {
          console.warn("Erro ao processar counter_number:", error);
        }
      }

      if (params.internal_number) {
        try {
          useFood.setIsInternalDelivery(true);
          const internalNumber = safeAtob(params.internal_number);
          if (internalNumber !== null) {
            useFood.setInternalDeliveryNumber(internalNumber);
            localStorage.setItem("internal_number", params.internal_number);
          }
        } catch (error) {
          console.warn("Erro ao processar internal_number:", error);
        }
      }

      if (params.internal_name) {
        try {
          useFood.setInternalDeliveryName(params.internal_name);
          localStorage.setItem("internal_name", params.internal_name);
        } catch (error) {
          console.warn("Erro ao processar internal_name:", error);
        }
      }

      // Handle navigation logic
      const hasSpecialParams = params.table_number || params.card_number || 
                              params.landmark_synkar || params.counter_number || 
                              params.internal_number || isKicked;

      if (hasSpecialParams) {
        try {
          localStorage.setItem(
            window.btoa("last_time_qrcode"),
            new Date().getTime().toString()
          );
        } catch (error) {
          console.warn("Erro ao salvar timestamp:", error);
        }

        const configuration: any = _config ? _config : config;

        if (!params.table_number && !params.card_number && !isKicked) {
          const targetRoute = configuration?.content?.pdv?.showLayout === "l2" 
            ? `/${params.pluginspace_id}/products-new`
            : `/${params.pluginspace_id}/products`;
          
          safeNavigate(targetRoute, { replace: true });
        } else if (configuration?.content?.pdv?.safeMode) {
          setIsOpenModalFood(true);
          return;
        }
      } else {
        try {
          localStorage.removeItem(window.btoa("last_time_qrcode"));
        } catch (error) {
          console.warn("Erro ao remover timestamp:", error);
        }
      }

      if (_config?.content?.pdv?.skipEntry && !isKicked) {
        enter(_config);
      }
    } catch (error) {
      console.error("Erro geral em loadTableCard:", error);
      // Fallback: tentar navegação básica
      safeNavigate(`/${params.pluginspace_id}/products`, { replace: true });
    }
  }

  async function getCategory() {
    setLoading(true);
    await api
      .post(
        "/api/classification/filter",
        {
          code: "1",
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data[0]) {
          setCategoryId(response.data.data[0].id);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function readQrcode(value: string) {
    try {
      if (value && typeof value === 'string') {
        // Validar se é uma URL válida antes de abrir
        try {
          new URL(value);
          window.open(value, "_self");
        } catch (urlError) {
          console.warn("URL inválida fornecida:", value);
          // Se não for uma URL válida, tentar como caminho relativo
          if (value.startsWith('/')) {
            window.location.href = value;
          }
        }
      }
    } catch (error) {
      console.error("Erro em readQrcode:", error);
    }
  }

  async function enter(_config?: ConfigType | void) {
    try {
      const configuration = _config ? _config : config;
      
      if (!configuration) {
        console.warn("Configuração não encontrada, usando rota padrão");
        safeNavigate(`/${params.pluginspace_id}/products`);
        return;
      }

      if (configuration.template === "retail" || configuration.template === "food") {
        const targetRoute = configuration.content?.pdv?.showLayout === "l2" 
          ? `/${params.pluginspace_id}/products-new`
          : `/${params.pluginspace_id}/products`;
        
        safeNavigate(targetRoute);
      } else {
        safeNavigate(`/${params.pluginspace_id}/category`);
      }
    } catch (error) {
      console.error("Erro em enter:", error);
      // Fallback para rota de produtos
      safeNavigate(`/${params.pluginspace_id}/products`);
    }
  }

  function login() {
    try {
      safeNavigate(`/${params.pluginspace_id}/auth`);
    } catch (error) {
      console.error("Erro em login:", error);
    }
  }

  async function getData() {
    const x = await getThisPluginspace();
    if (x) {
      setPluginspace(x);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    let isNavigating = false;
    
    const handlePopState = (event: PopStateEvent) => {
      if (isNavigating) return;
      
      try {
        // Permitir navegação se estivermos saindo da home
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/home') && !currentPath.endsWith(`/${params.pluginspace_id}`)) {
          return;
        }
        
        // Bloquear apenas se estivermos tentando voltar para uma página anterior da home
        window.history.pushState(null, "", window.location.href);
      } catch (error) {
        console.warn("Erro no handler de popstate:", error);
      }
    };

    // Adicionar estado inicial apenas se necessário
    try {
      if (!window.history.state) {
        window.history.replaceState({ page: 'home' }, "", window.location.href);
      }
    } catch (error) {
      console.warn("Erro ao configurar history state:", error);
    }

    window.addEventListener("popstate", handlePopState);

    return () => {
      isNavigating = true;
      window.removeEventListener("popstate", handlePopState);
    };
  }, [params.pluginspace_id]);

  useEffect(() => {
    let interactionTimer: NodeJS.Timeout;
    
    try {
      // Bloqueia a interação do usuário apenas se necessário
      if (loading) {
        document.body.style.pointerEvents = "none";
        
        // Desbloqueia após um período mais curto
        interactionTimer = setTimeout(() => {
          document.body.style.pointerEvents = "auto";
        }, 500);
      } else {
        document.body.style.pointerEvents = "auto";
      }
    } catch (error) {
      console.warn("Erro ao gerenciar pointer events:", error);
      // Garantir que os eventos sejam sempre reabilitados
      document.body.style.pointerEvents = "auto";
    }

    return () => {
      if (interactionTimer) {
        clearTimeout(interactionTimer);
      }
      // Sempre reabilitar eventos ao desmontar
      try {
        document.body.style.pointerEvents = "auto";
      } catch (error) {
        console.warn("Erro ao restaurar pointer events:", error);
      }
    };
  }, [loading]);

  return (
    <div className="home">
      {loading ? (
        <div style={{ width: "100%", height: "calc(100vh)" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div
          className="content-home"
          style={
            config?.background
              ? {
                  backgroundImage: `url(${config?.background})`,
                  backgroundSize: "cover",
                }
              : {
                  backgroundColor: config?.webappcolor.backgroundwebapp
                    ? config?.webappcolor.backgroundwebapp
                    : "#FFF",
                }
          }
        >
          <div className="logo-home">
            {config?.img && !config.img.includes("null") && (
              <img src={config.img} alt="Logo" />
            )}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: config?.info ? config.info : "",
            }}
          ></div>
          <div className="actions-homes">
            {pluginSpace?.appLogin && pluginSpace?.appLogin && (
              <>
                <MainButton
                  color={
                    config?.webappcolor.fontbuttonhome
                      ? config.webappcolor.fontbuttonhome
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.backgroundbuttonhome ? "#AAA" : "#AAA"
                  }
                  text="Login"
                  onClick={login}
                />
              </>
            )}
            <MainButton
              color={
                config?.webappcolor.fontbuttonhome
                  ? config.webappcolor.fontbuttonhome
                  : "#636363"
              }
              backgroundColor={
                config?.webappcolor.backgroundbuttonhome
                  ? config.webappcolor.backgroundbuttonhome
                  : "#EAEAEA"
              }
              text="Entrar"
              onClick={() => enter()}
            />
          </div>
          <div className="footer-home">
            {config?.content.useLogoTotvs && (
              <img
                src={
                  config &&
                  config.content &&
                  config.content.colorLogo === "white"
                    ? TotvsWhiteImg
                    : TotvsBlackImg
                }
                alt="TOTVS"
                className="totvs-img"
              />
            )}
            {config?.content.useLogoTotvs && (
              <h2
                style={{
                  color:
                    config &&
                    config.content &&
                    config.content.colorLogo === "white"
                      ? "white"
                      : "black",
                }}
              >
                by
              </h2>
            )}
            <img
              src={
                config && config.content && config.content.colorLogo === "white"
                  ? NinegridWhiteImg
                  : NinegridBlackImg
              }
              alt="Ninegrid by pluginbot"
              className="ninegrid-img"
            />
          </div>
        </div>
      )}

      <ModalComandaFood
        isOpen={isOpenModalFood}
        setIsOpen={setIsOpenModalFood}
        enter={enter}
      />

      {openCamera && <QrReader setScannedResult={readQrcode} />}
    </div>
  );
}
